import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, DownloadIcon, ListIcon } from 'lucide-react';
interface MaterialListProps {
  onBack: () => void;
}
export const MaterialList: React.FC<MaterialListProps> = ({
  onBack
}) => {
  // Mock data for material list
  const materialGroups = [{
    id: 'storey-1-manifold-1',
    name: 'Storey 1 / Manifold 1',
    items: [{
      id: 'item-1',
      vvsNo: '087B1165',
      description: 'QuickTemp Compact Basic, 3 kredse',
      quantity: 1,
      unitPrice: 2450,
      totalPrice: 2450
    }, {
      id: 'item-2',
      vvsNo: '087B1110',
      description: 'Rør 16x2,0 mm, 200 m',
      quantity: 2,
      unitPrice: 1200,
      totalPrice: 2400
    }, {
      id: 'item-3',
      vvsNo: '087B1210',
      description: 'Vendebøjninger 16 mm',
      quantity: 6,
      unitPrice: 25,
      totalPrice: 150
    }, {
      id: 'item-4',
      vvsNo: '087B1310',
      description: 'Touchline SL rumtermostat',
      quantity: 3,
      unitPrice: 550,
      totalPrice: 1650
    }]
  }, {
    id: 'storey-2-manifold-1',
    name: 'Storey 2 / Manifold 1',
    items: [{
      id: 'item-5',
      vvsNo: '087B1165',
      description: 'QuickTemp Compact Basic, 2 kredse',
      quantity: 1,
      unitPrice: 2250,
      totalPrice: 2250
    }, {
      id: 'item-6',
      vvsNo: '087B1110',
      description: 'Rør 16x2,0 mm, 200 m',
      quantity: 1,
      unitPrice: 1200,
      totalPrice: 1200
    }, {
      id: 'item-7',
      vvsNo: '087B1210',
      description: 'Vendebøjninger 16 mm',
      quantity: 4,
      unitPrice: 25,
      totalPrice: 100
    }, {
      id: 'item-8',
      vvsNo: '087B1310',
      description: 'Touchline SL rumtermostat',
      quantity: 2,
      unitPrice: 550,
      totalPrice: 1100
    }]
  }];
  const shippingInfo = {
    cost: 450,
    charged: 495,
    margin: 45
  };
  const discounts = [{
    id: 'discount-1',
    name: 'Årsrabat',
    value: '10%'
  }, {
    id: 'discount-2',
    name: 'Fast rabat',
    value: '5%'
  }, {
    id: 'discount-3',
    name: 'Kategori-rabat',
    value: 'Variabel'
  }];
  // Calculate totals
  const calculateSubtotal = () => {
    return materialGroups.reduce((total, group) => {
      return total + group.items.reduce((groupTotal, item) => groupTotal + item.totalPrice, 0);
    }, 0);
  };
  const subtotal = calculateSubtotal();
  const total = subtotal + shippingInfo.charged;
  return <div className="mb-20" data-id="element-146">
      <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6" data-id="element-147">
        <div className="p-6 border-b border-gray-200" data-id="element-148">
          <div className="flex justify-between items-center" data-id="element-149">
            <h2 className="text-xl font-semibold text-gray-800" data-id="element-150">
              Materialeliste & pris
            </h2>
            <div className="flex space-x-2" data-id="element-151">
              <button className="flex items-center px-3 py-1.5 border border-gray-300 rounded-md text-sm text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-152">
                <DownloadIcon className="w-4 h-4 mr-2" data-id="element-153" />
                Download materialeliste (PDF)
              </button>
            </div>
          </div>
        </div>
        {/* Material list */}
        <div className="p-6" data-id="element-154">
          {materialGroups.map(group => <div key={group.id} className="mb-8" data-id="element-155">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-156">
                {group.name}
              </h3>
              <div className="overflow-x-auto" data-id="element-157">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-158">
                  <thead data-id="element-159">
                    <tr data-id="element-160">
                      <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-161">
                        VVS-nr.
                      </th>
                      <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-162">
                        Beskrivelse
                      </th>
                      <th className="px-4 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-163">
                        Antal
                      </th>
                      <th className="px-4 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-164">
                        Stk. pris
                      </th>
                      <th className="px-4 py-3 bg-gray-50 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-165">
                        Total pris
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-166">
                    {group.items.map(item => <tr key={item.id} className="hover:bg-gray-50" data-id="element-167">
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-168">
                          {item.vvsNo}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-800" data-id="element-169">
                          {item.description}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600 text-right" data-id="element-170">
                          {item.quantity}
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600 text-right" data-id="element-171">
                          {item.unitPrice.toLocaleString('da-DK')} kr.
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-800 text-right" data-id="element-172">
                          {item.totalPrice.toLocaleString('da-DK')} kr.
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>)}
          {/* Shipping and totals */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-173">
            <div data-id="element-174">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-175">Fragt</h3>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-176">
                <div className="grid grid-cols-2 gap-2 text-sm" data-id="element-177">
                  <div className="text-gray-600" data-id="element-178">Fragt (cost)</div>
                  <div className="text-right font-medium text-gray-800" data-id="element-179">
                    {shippingInfo.cost.toLocaleString('da-DK')} kr.
                  </div>
                  <div className="text-gray-600" data-id="element-180">Fragt (faktureret)</div>
                  <div className="text-right font-medium text-gray-800" data-id="element-181">
                    {shippingInfo.charged.toLocaleString('da-DK')} kr.
                  </div>
                  <div className="text-gray-600" data-id="element-182">Fragt-DB</div>
                  <div className="text-right font-medium text-green-600" data-id="element-183">
                    {shippingInfo.margin.toLocaleString('da-DK')} kr.
                  </div>
                </div>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mt-6 mb-4" data-id="element-184">
                Rabatter
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-185">
                {discounts.map(discount => <div key={discount.id} className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm" data-id="element-186">
                    {discount.name}: {discount.value}
                  </div>)}
              </div>
            </div>
            <div data-id="element-187">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-188">
                Totaler
              </h3>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-189">
                <div className="space-y-3" data-id="element-190">
                  <div className="flex justify-between items-center" data-id="element-191">
                    <div className="text-gray-600" data-id="element-192">Subtotal</div>
                    <div className="font-medium text-gray-800" data-id="element-193">
                      {subtotal.toLocaleString('da-DK')} kr.
                    </div>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-194">
                    <div className="text-gray-600" data-id="element-195">Fragt</div>
                    <div className="font-medium text-gray-800" data-id="element-196">
                      {shippingInfo.charged.toLocaleString('da-DK')} kr.
                    </div>
                  </div>
                  <div className="pt-3 border-t border-gray-200" data-id="element-197">
                    <div className="flex justify-between items-center" data-id="element-198">
                      <div className="text-gray-800 font-medium" data-id="element-199">Total</div>
                      <div className="text-xl font-semibold text-gray-800" data-id="element-200">
                        {total.toLocaleString('da-DK')} kr.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-8 space-y-3" data-id="element-201">
                <button className="w-full px-4 py-2 bg-[#E3000F] text-white font-medium rounded-md hover:bg-red-700 transition-colors" data-id="element-202">
                  Overfør til tilbud
                </button>
                <button className="w-full px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-md hover:bg-gray-50 transition-colors" data-id="element-203">
                  <ListIcon className="w-4 h-4 inline-block mr-2" data-id="element-204" />
                  Åbn Good/Better/Best
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between" data-id="element-205">
        <button onClick={onBack} className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors" data-id="element-206">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-207" />
          Tilbage
        </button>
      </div>
    </div>;
};